import { apiRequest } from '../../apiRequest'

export const captureOrder = (data) => apiRequest('/payment/capture-order/').post(data)

export const captureEntry = (data) => apiRequest('/payment/capture-entry/').post(data)

export const createCheckout = (data) => apiRequest('/user/create-checkout/').post(data)
